export function isMacintosh() {
  return typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Mac') > -1;
}
